// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "datapipelines/v1/datapipelines.proto" (package "datapipelines.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private data managment RPCs and protos
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { TabularDataSourceType } from "../../app/data/v1/data";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message datapipelines.v1.ListDataPipelineSummariesRequest
 */
export interface ListDataPipelineSummariesRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message datapipelines.v1.GetDataPipelineSummaryRequest
 */
export interface GetDataPipelineSummaryRequest {
    /**
     * @generated from protobuf field: string pipeline_id = 1;
     */
    pipelineId: string;
}
/**
 * @generated from protobuf message datapipelines.v1.GetDataPipelineSummaryResponse
 */
export interface GetDataPipelineSummaryResponse {
    /**
     * @generated from protobuf field: datapipelines.v1.DataPipelineSummary summary = 1;
     */
    summary?: DataPipelineSummary;
}
/**
 * @generated from protobuf message datapipelines.v1.DataPipelineSummary
 */
export interface DataPipelineSummary {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string schedule = 3;
     */
    schedule: string;
    /**
     * @generated from protobuf field: bool enabled = 4;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: bool backfill_enabled = 5;
     */
    backfillEnabled: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_data_start_time = 6;
     */
    lastDataStartTime?: Timestamp;
    /**
     * @generated from protobuf field: uint32 errors_count = 7;
     */
    errorsCount: number;
    /**
     * @generated from protobuf field: int32 backfill_pct_complete = 8;
     */
    backfillPctComplete: number;
    /**
     * @generated from protobuf field: repeated bytes mql_binary = 9;
     */
    mqlBinary: Uint8Array[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 10;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: viam.app.data.v1.TabularDataSourceType data_source_type = 11;
     */
    dataSourceType: TabularDataSourceType;
    /**
     * @generated from protobuf field: datapipelines.v1.DisableReason disable_reason = 12;
     */
    disableReason: DisableReason;
    /**
     * @generated from protobuf field: bool standard_fallback_disabled = 13;
     */
    standardFallbackDisabled: boolean;
}
/**
 * @generated from protobuf message datapipelines.v1.ListDataPipelineSummariesResponse
 */
export interface ListDataPipelineSummariesResponse {
    /**
     * @generated from protobuf field: repeated datapipelines.v1.DataPipelineSummary summaries = 1;
     */
    summaries: DataPipelineSummary[];
}
/**
 * @generated from protobuf enum datapipelines.v1.DisableReason
 */
export enum DisableReason {
    /**
     * @generated from protobuf enum value: DISABLE_REASON_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DISABLE_REASON_USER = 1;
     */
    USER = 1,
    /**
     * @generated from protobuf enum value: DISABLE_REASON_AUTO_UNHEALTHY = 2;
     */
    AUTO_UNHEALTHY = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class ListDataPipelineSummariesRequest$Type extends MessageType<ListDataPipelineSummariesRequest> {
    constructor() {
        super("datapipelines.v1.ListDataPipelineSummariesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datapipelines.v1.ListDataPipelineSummariesRequest
 */
export const ListDataPipelineSummariesRequest = new ListDataPipelineSummariesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDataPipelineSummaryRequest$Type extends MessageType<GetDataPipelineSummaryRequest> {
    constructor() {
        super("datapipelines.v1.GetDataPipelineSummaryRequest", [
            { no: 1, name: "pipeline_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datapipelines.v1.GetDataPipelineSummaryRequest
 */
export const GetDataPipelineSummaryRequest = new GetDataPipelineSummaryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDataPipelineSummaryResponse$Type extends MessageType<GetDataPipelineSummaryResponse> {
    constructor() {
        super("datapipelines.v1.GetDataPipelineSummaryResponse", [
            { no: 1, name: "summary", kind: "message", T: () => DataPipelineSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datapipelines.v1.GetDataPipelineSummaryResponse
 */
export const GetDataPipelineSummaryResponse = new GetDataPipelineSummaryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataPipelineSummary$Type extends MessageType<DataPipelineSummary> {
    constructor() {
        super("datapipelines.v1.DataPipelineSummary", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "schedule", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "backfill_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "last_data_start_time", kind: "message", T: () => Timestamp },
            { no: 7, name: "errors_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "backfill_pct_complete", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "mql_binary", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ },
            { no: 10, name: "created_on", kind: "message", T: () => Timestamp },
            { no: 11, name: "data_source_type", kind: "enum", T: () => ["viam.app.data.v1.TabularDataSourceType", TabularDataSourceType, "TABULAR_DATA_SOURCE_TYPE_"] },
            { no: 12, name: "disable_reason", kind: "enum", T: () => ["datapipelines.v1.DisableReason", DisableReason, "DISABLE_REASON_"] },
            { no: 13, name: "standard_fallback_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datapipelines.v1.DataPipelineSummary
 */
export const DataPipelineSummary = new DataPipelineSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDataPipelineSummariesResponse$Type extends MessageType<ListDataPipelineSummariesResponse> {
    constructor() {
        super("datapipelines.v1.ListDataPipelineSummariesResponse", [
            { no: 1, name: "summaries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DataPipelineSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message datapipelines.v1.ListDataPipelineSummariesResponse
 */
export const ListDataPipelineSummariesResponse = new ListDataPipelineSummariesResponse$Type();
/**
 * @generated ServiceType for protobuf service datapipelines.v1.InternalDataPipelinesService
 */
export const InternalDataPipelinesService = new ServiceType("datapipelines.v1.InternalDataPipelinesService", [
    { name: "ListDataPipelineSummaries", options: {}, I: ListDataPipelineSummariesRequest, O: ListDataPipelineSummariesResponse },
    { name: "GetDataPipelineSummary", options: {}, I: GetDataPipelineSummaryRequest, O: GetDataPipelineSummaryResponse }
]);
